import React from 'react';
import ReactDOM from 'react-dom';
import '@progress/kendo-theme-default/dist/all.css';
import '../../leads/kendo-override.css'
import FilesApp from './apps/FilesApp';

const e = React.createElement;

const imagesContainer = document.querySelector('#imagescomponent');

if (imagesContainer) {
    ReactDOM.render(e(FilesApp, { templateContainerID: imagesContainer.dataset.templateId, configContainerID: imagesContainer.dataset.configId }), imagesContainer);
}

const filesContainer = document.querySelector('#filescomponent');

if (filesContainer) {
    ReactDOM.render(e(FilesApp, { templateContainerID: filesContainer.dataset.templateId, configContainerID: filesContainer.dataset.configId }), filesContainer);
}